// extracted by mini-css-extract-plugin
module.exports = {"suggest-error":"_6c97079b1b--suggest-error--MNDW6","error-text":"_6c97079b1b--error-text--3jlQO"};